import { Fields } from '@measured/puck';
import BackgroungColorComponent, {
  IBackgroundProps,
} from '../../components/customComponents/BackgroungColorComponent';

export interface IBackgroundFieldsProps {
  background: IBackgroundProps;
}

export const backgroungFields: Fields<IBackgroundFieldsProps> = {
  background: {
    type: 'custom',
    label: 'Margin',
    render: ({ value, onChange }) => {
      return <BackgroungColorComponent value={value} onChange={onChange} />;
    },
  },
};
